<template>
    <div class="bg-white flex flex-col h-52 p-4 min-w-336 ">
        <div class="flex flex-shrink font-bold">Alert Manuale</div>
        <div class="flex-grow">
            <p class="flex-shrink text-sm">{{ descrizione }}</p>
        </div>
        <div class="flex justify-between">
            <div v-if="abilitato !== '0'" class="basis-1/2 flex  flex-col items-start">
                <div class="flex-shrink text-sm">Scadenza</div>
                <div class="flex-shrink text-2xl">{{ scadenza }}</div>
            </div>
            <div v-else class="basis-1/2 flex  flex-col items-start">
                <div class="flex-shrink text-sm">Completato il</div>
                <div class="flex-shrink text-2xl">{{ updated_at }}</div>
            </div>
            <div v-if="abilitato !== '0'" class="flex items-center self-end">
                <p @click="$emit('update', id)" class="cursor-pointer underline ml-2">Modifica</p>
                <NextButton @click="changeState" variant="outline-secondary" class="basis-1/4 px-3 py-1 ml-3 whitespace-nowrap">
                    {{label}}
                </NextButton>
            </div>
            <div v-else class="flex items-center self-end">
                <NextButton variant="primary" @click="$emit('delete', id)"
                        class="basis-1/4 px-3 py-1 ml-3 whitespace-nowrap">Elimina</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import alertManager from "../api/Alert";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'AlertManuale',
    components: {NextButton},
    props: {
        id: [String, Number],
        descrizione: String,
        scadenza: String,
        abilitato: [Boolean,Number,String],
        updated_at: String
    }
})
export default class AlertManuale extends Vue {
    id!: string
    descrizione!: string
    scadenza!: string
    abilitato!: boolean|number
    updated_at!: string

    changeState(){
        alertManager.toggleState(this.id).then(()=>{
            this.$emit('stateChange')
        })
    }

    get label(){
        return this.abilitato? 'Fatto': 'Da fare'
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
